module.exports = __webpack_public_path__ + "img/2.230bb322.png";